import RaceSummary from './container';

export default RaceSummary;



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/index.jsx